export const GA_MEASUREMENT_ID = 'G-V200NTL7CP';

// Fix for 'dataLayer' is not defined
window.dataLayer = window.dataLayer || [];
function gtag(){window.dataLayer.push(arguments);}
export function initGoogleAnalytics() {
  // Check consent before loading
  const consent = localStorage.getItem('lucods_cookie_consent');
  if (consent === 'rejected') return;
  if (consent && consent !== 'accepted') {
    try {
      const prefs = JSON.parse(consent);
      if (!prefs.analytics) return;
    } catch {}
  }
  // Load the Google Analytics script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);
};
